/**
 * Debug utility - only logs when REACT_APP_DEBUG=true in .env
 */

const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

export const debug = {
  log: (...args) => {
    if (isDebugEnabled) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isDebugEnabled) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDebugEnabled) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isDebugEnabled) {
      console.info(...args);
    }
  }
};
